import React, { useState } from 'react';
import styles from './mail-confirmation-input.module.scss';
import { DefaultButton, FormInput } from 'shared/ui';
import { SSOApi } from 'shared/api';
import { VerificationCodeEnum } from 'shared/types';

interface IMailConfirmationInputProps {
  onChange?: (value: string) => void;
  setKey?: (value: string, mail: string) => void;
  mail?: string;
  type: VerificationCodeEnum;
}

export const MailConfirmationInput: React.FC<IMailConfirmationInputProps> = ({
  onChange,
  setKey,
  mail,
  type,
}) => {
  const [newMail, setNewMail] = useState(mail ?? '');
  const [code, setCode] = useState('');
  const [viewCodeSendedInput, setViewCodeSendedInput] = useState(false);
  const [viewCodeSendedButton, setViewCodeSendedButton] = useState(true);
  const [error, setError] = useState('');

  const sendMailForCode = async () => {
    try {
      setViewCodeSendedButton(false);
      await SSOApi.emailSendCode({ email: newMail, type });
      setViewCodeSendedInput(true);
    } catch (error) {
      setViewCodeSendedInput(false);
      setViewCodeSendedButton(true);
      if (error instanceof Error) {
        setError(error.message);
      }
    }
  };

  const confirmCode = async () => {
    try {
      const res = await SSOApi.emailConfirmation({
        email: newMail,
        code,
        type,
      });
      setViewCodeSendedInput(false);
      if (onChange) {
        onChange(newMail);
      }
      if (setKey && type == VerificationCodeEnum.ACCOUNT_RESTORE) {
        setKey(res.changePasswordKey, newMail);
      }
    } catch (error) {
      setViewCodeSendedButton(true);
      if (error instanceof Error) {
        setError(error.message);
      }
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.container__mail_input}>
        <div className={styles.mail_input__input}>
          <FormInput
            inputTitle="Почта"
            inputPlaceholder="Электронная почта"
            onChange={(value) => {
              setNewMail(value);
              setViewCodeSendedButton(true);
              setError('');
              if (onChange) {
                onChange('');
              }
            }}
          />
        </div>
        <div className={styles.mail_input__error}>{error}</div>
        {viewCodeSendedButton ? (
          <div className={styles.mail_input__button}>
            <DefaultButton
              buttonText="Отправить код"
              color="green"
              onClick={sendMailForCode}
            />
          </div>
        ) : null}
      </div>
      {viewCodeSendedInput ? (
        <div className={styles.container__confirm_input}>
          <div className={styles.confirm_input__input}>
            <FormInput
              inputTitle="Код подтверждения"
              inputPlaceholder="XXXXXX"
              onChange={(value) => {
                setCode(value);
              }}
            />
          </div>
          <div className={styles.confirm_input__button}>
            <DefaultButton
              buttonText="Подтвердить"
              color="green"
              onClick={confirmCode}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};
